// skills | Work
export const getSkills = "getSkills";
export const getWork = "getWork";